module.exports = __webpack_public_path__ + "static/trinity-b3e7624f19bbbf8afc0b6a3967bb7266.png";